import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
    width: '100%',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const BusPlateNumberDropdown = ({ busVendorID, getBusPlateNo, clearSelect }) => {
    const [busPlateNo, setBusPlateNo] = useState([]);

    const options = busPlateNo;

    const [selectedOption, setSelectedOption] = useState('');

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getBusVendors = async () => {
            const busVendorFromServer = await fetchBusVendors();
            const id = await busVendorID;
            const busVendor = busVendorFromServer.find(busVendor => busVendor.id === id);
            const busVendorMap = busVendor.buses.map((item => ({ value: item.id, label: item.plate_number })));
            setBusPlateNo(busVendorMap.sort((a, b) => a.label.localeCompare(b.label)));
        };

        clearSelect && setSelectedOption(null)

        getBusVendors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [busPlateNo, busVendorID, clearSelect]);

    const fetchBusVendors = async () => {
        try {
            const res = await fetch(REACT_APP_API_BACKEND_URL + '/api/busdriver/vendor', { mode: 'cors' });
            const data = await res.json();
            
            return data;
        }
        catch (err) {
            console.log(err)
        }
    };

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        
        getBusPlateNo(selectedOption);
    };

    return (
        <Select
            placeholder={'Select a bus plate number...'}
            components={{ Control: ControlComponent }}
            isClearable
            value={selectedOption}
            onChange={handleChange}
            options={options}
        />
    );
};

export default BusPlateNumberDropdown;
